import {Ref, ref} from "vue";
import {LoadingState} from "@/services/contracts/LoadingState";
import {ICompetitionList} from "@/services/contracts/ICompetitionList";
import CompetitionService from "@/services/CompetitionService";
import {defineStore} from "pinia";
import {logError} from "@/services/support/error";

export const useCompetitionListStore
    = defineStore('competitions', () => {

    const EMPTY: ICompetitionList = {items: []};
    const loadingState = ref(LoadingState.LOADING);
    const list: Ref<ICompetitionList> = ref(EMPTY);

    async function fetch() {

        console.debug('Fetching competitions...');
        loadingState.value = LoadingState.LOADING;

        try {
            const response = await CompetitionService.find();
            list.value = response.data;
            loadingState.value = LoadingState.OK;
        } catch (err) {
            list.value = EMPTY;
            loadingState.value = LoadingState.ERROR;
            logError('Failed to fetch competitions', err);
        }
    }

    return {list, loadingState, fetch}
});